export default "__VITE_ASSET__58877215__"